import { render, staticRenderFns } from "./footerUpNew.vue?vue&type=template&id=eccfe568&scoped=true&"
import script from "./footerUpNew.vue?vue&type=script&lang=js&"
export * from "./footerUpNew.vue?vue&type=script&lang=js&"
import style0 from "./footerUpNew.vue?vue&type=style&index=0&id=eccfe568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccfe568",
  null
  
)

export default component.exports